import type { IconProps } from './icons.types';

export function RemoveIcon({ size = 16 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 13 2" fill="currentColor" aria-hidden="true">
      <path d="M0 1.5V0H13V1.5H0Z" />
    </svg>
  );
}
